export const NOTIFY_ME = 'NOTIFY_ME';
export const NOTIFY_SUCCESS = 'NOTIFY_SUCCESS';
export const NOTIFY_FAILED = 'NOTIFY_FAILED';
export const NOTIFY_DISMISS = 'NOTIFY_DISMISS';